import EventBus from '../primitives/event-bus'
import Modal from './modal'

interface ModalEventMap {
  show: (notification: Modal) => void
}

const eventBus = new EventBus<ModalEventMap>()

export default eventBus
